import { Box, Stack, Text, type BoxProps } from "@bookingcom/bui-react";
import styles from "../CampaignImpact.module.css";

type InfoBoxCardProps = {
  backgroundColor: BoxProps["backgroundColor"];
  title: string;
  children: React.ReactNode;
};

export const InfoBoxCard = ({ backgroundColor, title, children }: InfoBoxCardProps) => (
  <Box backgroundColor={backgroundColor} borderRadius={200} mixin={{ padding: 4 }} className={styles.infoBox}>
    <Stack direction="column" gap={2}>
      <Text variant="strong_1">{title}</Text>
      {children}
    </Stack>
  </Box>
);
